import http from '@/http/aisea/axios'
const resource = "/enterprise";

export default {
  fetch() {
    return http.get(`${resource}`);
  },
  update(payload) {
    return http.post(`${resource}`, payload);
  },

};
